<template>
  <div class="storeManage-list">
    <GlobalInfoBar
        title="门店管理"
        content="添加门店，查看/编辑已添加的门店信息"
    />
    <GlobalChunkNo
        icon="search"
        title="筛选查询"
    >
      
      <div slot="filter">
        <storeManageFrom :isOpenBuyNiceMachine="isOpenSelfBuyNiceMachine" />
      </div>

      <storeManageTable :isOpenBuyNiceMachine="isOpenSelfBuyNiceMachine" />
    </GlobalChunkNo>
  </div>
</template>

<script>
import _api from "@/utils/request";
import storeManageFrom from './From'
import storeManageTable from './Table'
export default {
  name: 'storeManage-list',
  components: {storeManageFrom,storeManageTable},
  data(){
    return{
      userName:"",
      userPhone:"",
      roleId:"",
      isOpenSelfBuyNiceMachine:""
    }
  },
  created(){
    this.getCompanyCustomConfig()
  },
  methods:{
     //获取	是否启用门店自收靓机开关 true 是 false 否
     getCompanyCustomConfig() {
      _api.getCompanyCustomConfig().then(res => {
        this.isOpenSelfBuyNiceMachine = res.data.isOpenSelfBuyNiceMachine
      })
    },
  }
}
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.merchant-list{
}
</style>
